module.exports = __webpack_public_path__ + "static/img/michelin.746cacb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xp/michelin.svg
// module id = VCl4
// module chunks = 1